"use client";

import { Facebook, Instagram, Linkedin, Compass, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[0, 1, 2, 3].map(i => <li key={i} data-index={i} className="h-4 w-24 bg-card animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm font-medium text-foreground hover:text-[var(--gold-accent,theme(colors.primary))] transition-colors duration-280 relative inline-block group">
            <span>{item.label}</span>
            <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-280 group-hover:w-full" />
          </Link>
        </li>)}
    </ul>;
}
const tickerItems = ["INNOVATION FIRST", "GLOBAL TECHNOLOGY STANDARDS", "CONSTRUCTION EXCELLENCE", "END-TO-END SOLUTIONS"];
const visitLinks = [{
  label: "Office Hours",
  href: "#"
}, {
  label: "Location",
  href: "#"
}, {
  label: "Support",
  href: "#"
}];
const socialLinks = [{
  label: "Instagram",
  href: "#",
  Icon: Instagram
}, {
  label: "Facebook",
  href: "#",
  Icon: Facebook
}, {
  label: "Google",
  href: "#",
  Icon: Star
}, {
  label: "LinkedIn",
  href: "#",
  Icon: Linkedin
}];
export default function ConnectWithUs() {
  return <section data-section-id="1691" id="connect-with-us" className="relative bg-background text-foreground overflow-hidden" style={{
    backgroundColor: "#0F0F0F"
  }}>
      {}
      <div className="relative w-full overflow-hidden border-b border-primary/15 py-3">
        <div className="flex whitespace-nowrap animate-[ticker_40s_linear_infinite] gap-12">
          {[...tickerItems, ...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-12 font-mono text-[11px] tracking-[0.18em] text-foreground/40 uppercase">
              <span>WEB HOSTING</span>
              <Compass className="h-3 w-3 text-primary shrink-0" strokeWidth={1.25} />
            </div>)}
        </div>
        <style>{`
          @keyframes ticker {
            0% { transform: translateX(0); }
            100% { transform: translateX(-33.333%); }
          }
        `}</style>
      </div>

      <div className="mx-auto max-w-[1320px] px-5 md:px-14 py-24">
        {}
        <div className="flex items-center gap-0 mb-16">
          <span className="h-1 w-1 bg-primary rounded-sm shrink-0" />
          <span className="h-px flex-1 bg-primary/40" />
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div className="lg:col-span-4 flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <WvcLogo className="h-9 w-auto" />
            </Link>
            <p className="text-base leading-relaxed text-muted-foreground max-w-sm font-default">
              NYLA Tech bridges the physical rigidity of construction with the fluid intelligence of software, delivering excellence from code to concrete.
            </p>
            <div className="font-mono text-[12px] leading-relaxed text-primary tracking-[0.08em] uppercase pt-2">
              
              <div className="text-foreground/50 mt-1">871 VAL PARK AVE</div>
              <div className="text-foreground/50">VALLEY STREAM, NY 11580</div>
            </div>
          </div>

          {}
          <div className="lg:col-span-3 flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <span className="font-mono text-[11px] tracking-[0.18em] text-primary uppercase font-medium">
                § Company
              </span>
              <div className="flex items-center gap-0">
                <span className="h-1 w-1 bg-primary rounded-sm" />
                <span className="h-px w-14 bg-primary/60" />
              </div>
            </div>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-2 flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <span className="font-mono text-[11px] tracking-[0.18em] text-primary uppercase font-medium">
                § Resources
              </span>
              <div className="flex items-center gap-0">
                <span className="h-1 w-1 bg-primary rounded-sm" />
                <span className="h-px w-14 bg-primary/60" />
              </div>
            </div>
            <ul className="flex flex-col gap-3">
              {visitLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-sm font-medium text-foreground hover:text-primary transition-colors duration-280 relative inline-block group">
                    <span>{link.label}</span>
                    <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-280 group-hover:w-full" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-3 flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <span className="font-mono text-[11px] tracking-[0.18em] text-primary uppercase font-medium">
                § Contact
              </span>
              <div className="flex items-center gap-0">
                <span className="h-1 w-1 bg-primary rounded-sm" />
                <span className="h-px w-14 bg-primary/60" />
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <Link to="#" className="font-default italic text-2xl text-primary leading-none hover:text-secondary transition-colors duration-280">(929) 261-7929</Link>
              <Link to="#" className="text-sm font-medium text-foreground hover:text-primary transition-colors duration-280 relative inline-block group w-fit">
                <span>nylatech28@gmail.com</span>
                <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-280 group-hover:w-full" />
              </Link>
              <div className="flex items-center gap-5 pt-3">
                {socialLinks.map(({
                label,
                href,
                Icon
              }, i) => <Link key={label} data-index={i} to={href} aria-label={label} className="text-primary hover:text-foreground transition-colors duration-280">
                    <Icon className="h-5 w-5" strokeWidth={1.25} />
                  </Link>)}
              </div>
            </div>
          </div>
        </div>

        {}
        <Separator className="mt-20 mb-8 bg-primary/15" />

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <span className="font-mono text-[11px] tracking-[0.08em] text-foreground/50 uppercase">© 2026 NYLA tECH LLC· All Rights Reserved</span>
          <div className="flex items-center gap-3">
            <Compass className="h-3.5 w-3.5 text-primary" strokeWidth={1.25} />
            <span className="font-mono text-[11px] tracking-[0.08em] text-foreground/50 uppercase">
              Engineered In New York
            </span>
          </div>
        </div>
      </div>
    </section>;
}